import { Outlet, Link } from "react-router-dom";
import styles from "./Layout.module.css";
import TelusLogoEN from "../../assets/TELUS_Logo_English.svg";
import TelusLogoFR from "../../assets/TELUS_Logo_French.svg";

import MobileChatSettings from '../../components/ChatSettings/MobileChatSettings/MobileChatSettings';
import DesktopChatSettings from '../../components/ChatSettings/DesktopChatSettings/DesktopChatSettings';
import {
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
} from "@fluentui/react-components";
import {Stack} from "@fluentui/react";
import { useContext, useEffect, useState } from "react";
import { UserGuideButton } from "../../components/common/Button";
import UserGuide from "../../components/UserGuide/UserGuide";
import { AppStateContext } from "../../state/AppProvider";
import {useTranslation} from "../../state/LanguageProvider";
import { FrontendSettings } from "../../api";
import LayoutSkeleton from "./LayoutSkeleton";
import { useChatContext } from '../../state/ChatContextProvider';
import CloseIcon from "../../assets/Close_Icon.svg";

const Layout = () => {
    const appStateContext = useContext(AppStateContext);
    const frontEndSettings: FrontendSettings = appStateContext?.state.frontendSettings!;
    const isMultiLang = frontEndSettings?.SUPPORT_MULTI_LANG || false;
    const isMutiContext = frontEndSettings?.SUPPORT_MULTI_CONTEXT || false; 
    const isChatSettingsEnabled = frontEndSettings?.CHAT_SETTINGS_ENABLED || false;
    
    const [isUserGuidePanelOpen, setIsUserGuidePanelOpen] = useState<boolean>(false);
    const { getTranslation, isLoading } = useTranslation();
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 700);
    const {availableChatContexts, chatRegionKey, regionExists} = useChatContext();

    const TelusLogos = {
        "TelusLogoEN": TelusLogoEN,
        "TelusLogoFR": TelusLogoFR,
    };
    const TelusLogo = TelusLogos[getTranslation("telus_logo") as keyof typeof TelusLogos];

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth < 700);
        };

        window.addEventListener('resize', handleResize);
        return () => {window.removeEventListener('resize', handleResize);};
      }, []);

    const handleUserGuideClick = () => {
        setIsUserGuidePanelOpen(true);
    };

    const handleUserGuidePanelDismiss = () => {
        setIsUserGuidePanelOpen(false);
    };

    function handleChatBotTitle(): string
    {
        const botName = getTranslation('bot_name')
        const existingBotName = botName.slice(0, botName.lastIndexOf(" "));
        if (regionExists)
        {
            let region: string = "";
            availableChatContexts.forEach((items) => {
                Object.entries(items).forEach(([key, value]) => {
                    if (key.toLowerCase() === "region") {
                        Object.entries(value).forEach(([subKey, subValue]) => {
                            if (subKey === chatRegionKey) {
                                region = subValue;
                            }
                        });
                    } 
                });
            });
            const selRegionName = region;
            const regionBotName = existingBotName.concat(" ", selRegionName);
            return regionBotName
        }
        else
            return botName
    };

    if (isLoading) {
        return <LayoutSkeleton />;
    }

    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <Stack className={styles.headerContainer}>
                    {isChatSettingsEnabled && isMobile && (
                        <MobileChatSettings isMultiLang={isMultiLang} isMultiContext={isMutiContext}/>
                    )}
                    <div className={styles.headerContainer1}>
                        <Stack horizontal verticalAlign="center">
                            <img
                                src={TelusLogo}
                                className={styles.headerIcon}
                                aria-hidden="true"
                            />
                            <div className={styles.headerTitleContainer}>
                                <h1 className={styles.headerTitle}>{ handleChatBotTitle() }</h1>
                            </div>
                        </Stack>
                    </div>
                    <Stack className={styles.headerContainer2} horizontal tokens={{ childrenGap: 20 }}>

                        <div id="header-portal-container"></div>

                        {                    
                            <Stack className={styles.headerIconContainer} onClick={handleUserGuideClick} horizontal tokens={{ childrenGap: 11 }}>
                                <UserGuideButton className={styles.userGuideButtonFlexContainer} />
                                <label className={styles.iconLabel}> {getTranslation("user_guide")} </label>
                            </Stack>
                        }

                    </Stack>
                </Stack>
            </header>
            
            {isChatSettingsEnabled && !isMobile ? (
                <div className={styles.flexContainerRow}> 
                    <DesktopChatSettings isMultiLang={isMultiLang} isMultiContext={isMutiContext}/>
                    <Outlet/>
                </div>
            ) : (
                <Outlet/>
            )}
            
            <Dialog
                open={isUserGuidePanelOpen}
                onOpenChange={(_, data) => setIsUserGuidePanelOpen(data.open)}
                modalType="modal"
            >
                <DialogSurface className={styles.userGuideDialogSurface}>
                    <DialogBody className={styles.userGuideDialogBody}>
                        <div className={styles.userGuideHeaderRow}>
                            <DialogTitle className={styles.userGuideDialogTitle}>
                                {getTranslation("general_user_guide")}
                            </DialogTitle>
                            <button
                                className={styles.userGuideCloseButton}
                                aria-label={getTranslation("close")}
                                onClick={() => setIsUserGuidePanelOpen(false)}
                            >
                                <img src={CloseIcon} alt={getTranslation("close")} className={styles.userGuideCloseIcon} />
                            </button>
                        </div>
                        <DialogContent className={styles.userGuideDialogContent}>
                            <Stack horizontal verticalAlign="center" style={{ gap: "8px" }}>
                                <div>
                                    <UserGuide />
                                </div>
                            </Stack>
                        </DialogContent>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        </div>
    );
};

export default Layout;